




import { defineComponent } from "@vue/composition-api";
import { mapActions, mapGetters } from "vuex";
import { tableHeaders } from "@monorepo/utils/src/variables/projectsData/fundsReportsView/tableHeaders";
import ToggleTableCells from "@monorepo/uikit/src/components/tableViews/ToggleTableCells.vue";
import { viewUniqKey } from "@monorepo/utils/src/variables/projectsData/fundsReportsView/viewTitle";

export default defineComponent({
  name: "ToggleTableCellsContainer",
  components: {
    ToggleTableCells,
  },
  data() {
    return {
      viewUniqKey,
      tableHeaders,
    };
  },
  computed: {
    ...mapGetters("fundsReportsView", ["cells"]),
  },
  methods: {
    ...mapActions("fundsReportsView", ["setCells"]),
  },
});
